import Footer from "../../Home/Footer";
import Header from "../../Home/Header";
import Adoption from "./Adoption";
import CryptoEScript from "./CryptoEScript";
import CryptoFeatures from "./CryptoFeatures";
import LaunchHero from "./LaunchHero";
import WeDeliver from "./WeDeliver";
import WhyBuild from "./WhyBuild";

import CryptoScript from "./CryptoScript";

function CryptocurrencyExchange() {
  return (
    <div>
      <Header />
      <LaunchHero />
      <WhyBuild />
      <CryptoFeatures />
      <WeDeliver />
      <CryptoScript />
      <CryptoEScript />
      <Adoption />
      <Footer />
    </div>
  );
}

export default CryptocurrencyExchange;
